// components/AddressAutocomplete.js
import React, { useState } from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import cookie from "js-cookie";
import axios from "axios";
import { useRouter } from "next/router";
import { savePincode } from "../../api.services.js/others";

const AddressAutocomplete = (props) => {
  const router = useRouter();
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [getLocationLoading, setgetLocationLoading] = useState(false);
  const [error, seterror] = useState(false);

  const handleSelect = async (address) => {
    setSelectedAddress(address);

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode(
      { placeId: address.value.place_id },
      async (results, status) => {
        if (status === "OK" && results[0]) {
          const location = results[0].geometry.location;
          let city = extractCityFromResults(results[0]);
          console.log(city);
          console.log(results[0]);
          const lat = location.lat();
          const lng = location.lng();

          if (!city) {
            const response = await axios.get(
              `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
            );
            const address = response.data.address;
            console.log(address);
            city = address.state;
          }

          localStorage.removeItem("stateFromAdvancedSearch");
          localStorage.removeItem("cityFromAdvancedSearch");

          localStorage.setItem("cityFromSimpleSearch", city);
          localStorage.setItem("latitude", lat);
          localStorage.setItem("longitude", lng);

          // Redirect to the store locator with city in the URL
          router.push(
            `/store-locator/${city.toLowerCase().replace(/\s+/g, "-")}`
          );
          setSelectedAddress("");
        } else {
          console.error("Error fetching geocode data:", status);
        }
      }
    );
  };

  // Extract city name from the address components
  const extractCityFromResults = (result) => {
    const cityComponent = result.address_components.find(
      (component) =>
        component.types.includes("locality") ||
        component.types.includes("administrative_area_level_2")
    );

    return cityComponent ? cityComponent.long_name : "";
  };

  const retrieveGeolocation = async () => {
    try {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          // timeout: 5000, // Set a timeout for geolocation retrieval (5 seconds)
        });
      });
      console.log("2", position);
      if (!router.asPath.includes("/tiles")) {
        props.setLocationPopop(false);
        props.setleadpopop();
        setgetLocationLoading(false);
      }
      const { latitude, longitude } = position.coords;

      const response = await axios.get(
        `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
      );
      const address = response.data.address;

      if (address && address.postcode) {
        const pincode = address.postcode;
        props.setLocationPopop(false);
        props.setleadpopop();
        localStorage.setItem("pincodeSkip", true);
        cookie.set("pincode", pincode);
        savePincode({ pincodedetails: pincode });
        setgetLocationLoading(false);
        if (router.asPath.includes("/tiles")) {
          router.reload();
        }
      }
    } catch (error) {
      console.error("Error retrieving location:", error);

      const errorMessage =
        error.message || "Something went wrong while retrieving your location.";
      swal(errorMessage);
    }
  };
  const extractPincodeFromResults = (result) => {
    const postalCodeComponent = result.address_components.find((component) =>
      component.types.includes("postal_code")
    );

    return postalCodeComponent ? postalCodeComponent.short_name : "";
  };

  const renderSuggestions = (active, suggestions, onSelectSuggestion) => {
    const filteredSuggestions = suggestions.filter((suggestion) => {
      const hasPostalCode = suggestion.terms.some((term) =>
        term.types.includes("postal_code")
      );
      return hasPostalCode;
    });

    return filteredSuggestions.map((suggestion) => {
      const isActive = active === suggestion.active;
      const classNames = `suggestion-item ${isActive ? "active" : ""}`;

      return (
        <div
          key={suggestion.placeId}
          className={classNames}
          onClick={() => onSelectSuggestion(suggestion)}
        >
          {suggestion.description}
        </div>
      );
    });
  };

  return (
    <>
      <GooglePlacesAutocomplete
        apiKey="AIzaSyBrmlHMs5JUON_ErXHEKk_HSd2UoLN20HQ"
        autocompletionRequest={{
          componentRestrictions: {
            country: ["in"],
          },
        }}
        selectProps={{
          value: selectedAddress,
          onChange: handleSelect,
          placeholder: "Search for your city",
        }}
        renderSuggestions={renderSuggestions}
      />
      {error && <p className="error text-danger">{error}</p>}
    </>
  );
};

export default AddressAutocomplete;
